import React from 'react';
import { useTranslation } from 'react-i18next';
import { HOME } from '../../../../../constants/define/translation';
import { IconCreateBlack } from '../../../../../assets';
import { ContentPageHeader, ExtraHeaderPage } from '../../../../molecules/page-header/ContentPageHeader';
// import { IconCreateBlack, IconPublish } from '../../../assets';

interface OtherGraphicHeaderProps {
  onOpenCreateImageModal?: () => void;
}

export const OtherGraphicsHeader = (props: OtherGraphicHeaderProps) => {
  const { t } = useTranslation(HOME);
  const { onOpenCreateImageModal } = props;

  const extra: ExtraHeaderPage[] = [
    {
      key: 1,
      text: t('header.buttonCreate'),
      bgWhite: 'true',
      onClick: onOpenCreateImageModal,
      icon: <IconCreateBlack />,
    },
    // { key: 2, text: t('header.buttonPublish'), icon: <IconPublish /> },
  ];

  return <ContentPageHeader title="Images" extra={extra} />;
};
